/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { Button, Modal } from '@scuf/common';
import React, { useContext, useEffect, useState } from 'react';
import './AddFuelCommon.scss';
import { useFileUploadContext } from '../../../context/FileUploadContext/FileUploadContext';
import FileUploadAction from '../../../context/FileUploadContext/FileUploadActions';
import descriptors from '../../../locales/en-US/descriptors';
import { useTranslation } from '@scuf/localization';
import SharedTabsWidget from '../../shared/SharedTabs/SharedTabs';
import ManualInputTabDetailsComponentWidget from './ManualInputTab/ManualInputTabDetailsComponentWidget';
import {
  fuelGasTypeLabelCheck,
  getModalTitle,
  getNotifyTypeForAddFuel
} from './AddFuelUtils';
import useConnectorForPost from '../../shared/useConnectorAndDynamicProps/useConnectorForPost';
import {
  IAny,
  IRequestContext
} from '../../DashboardKPIWidgets/IEnergyManagementProps';
import { MAGIC_VALUE, parseIntBase } from '../../shared/Utils/Constants';
import { ApiContext } from '../../../context/ApiContext';
import FileUploadActions from '../../../context/FileUploadContext/FileUploadActions';
interface IAddFuel {
  requestContext: IRequestContext;
  activeIndexDataUpload: number;
  toggleFeatureAllUpload?: boolean;
  toggleFeatureScopeOne?: boolean;
  toggleFeatureScopeTwo?: boolean;
  toggleFeatureGAS?: boolean;
  tableData?: IAny;
  countryCode?: string;
  setCancelPopup?: IAny;
}

function AddFuelModal(props: IAddFuel) {
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  const { requestContext, countryCode, setCancelPopup } = props;
  const [AddFuelDisabled, setAddFuelDisabled] = useState(false);
  const [state, dispatch] = useFileUploadContext();
  const [updateDisabled, setUpdateDisabled] = useState(true);
  const {
    showAddFuelModal,
    selectedFuelMonthData,
    modalType,
    isEditButtonEnabled,
    apiPayload
  } = state;
  const apiContext = useContext(ApiContext);
  const { notifyMessage } = apiContext;
  const closeModal = () => {
    dispatch(FileUploadAction.hideAddFuelModal());
    setCancelPopup(true);
  };
  const displayTabs = {
    displayTabs: [
      {
        className: 'emaas-addfuelModal-tab',
        title: t(d.MANUALINPUT),
        component: ManualInputTabDetailsComponentWidget
      }
    ],
    ActiveIndex: 0,
    selectedFuelMonthData,
    modalType,
    setAddFuelDisabled,
    setUpdateDisabled,
    activeIndexDataUpload: props.activeIndexDataUpload,
    toggleFeatureAllUpload: props.toggleFeatureAllUpload,
    tableData: props.tableData,
    toggleFeatureScopeOne: props?.toggleFeatureScopeOne,
    toggleFeatureScopeTwo: props?.toggleFeatureScopeTwo,
    toggleFeatureGAS: props?.toggleFeatureGAS,
    countryCode: countryCode
  };
  const renderModel = () => {
    return (
      <>
        <SharedTabsWidget {...displayTabs} />
        {renderFooterButtons()}
      </>
    );
  };
  const connectorConfig = {
    name: 'save-scope-one-fuel-data'
  };
  const dataConnector = useConnectorForPost({
    connectorConfig: connectorConfig,
    requestContext
  });
  const saveData = async () => {
    let result: IAny = {};
    let categoryName;

    categoryName = fuelGasTypeLabelCheck(
      props.activeIndexDataUpload,
      'stationaryCombustion',
      'refrigerants',
      props.toggleFeatureAllUpload,
      props.toggleFeatureScopeOne,
      props.toggleFeatureScopeTwo,
      'scope2',
      props.toggleFeatureGAS,
      'GAS'
    );
    let payload: {} = {
      emissionFactorId: apiPayload.emissionFactorId,
      unit: apiPayload.unit,
      emissionFactor: parseFloat(apiPayload.Co2),
      category: categoryName,
      isOverRide: apiPayload.overRideFlag,
      siteId: requestContext.context.siteId,
      userId: requestContext.context.userID,
      countryCode: '',
      stateCode: '',
      regionId: '',
      consumptionDetails: apiPayload.details.map(
        (monthlyData: { quantity: string; month: string; year: string }) => {
          return {
            quantity: parseFloat(monthlyData.quantity),
            month: monthlyData.month.substring(0, MAGIC_VALUE.THREE),
            year: parseInt(apiPayload.year, parseIntBase)
          };
        }
      )
    };
    const categoryArray = ['GAS', 'scope2'];
    if (categoryArray.includes(categoryName as any)) {
      payload = {
        emissionFactorId: apiPayload.emissionFactorId,
        unit: apiPayload.unit,
        emissionFactor: parseFloat(apiPayload.Co2),
        category: categoryName === 'GAS' ? 'scope2' : categoryName,
        //isOverRide: apiPayload.overRideFlag,
        isOverRide: true,
        countryCode: apiPayload.countryCode,
        fuelTypeUnitId: apiPayload.fuelTypeUnitId,
        stateCode: apiPayload.stateCode,
        regionId: apiPayload.regionId,
        year: parseInt(apiPayload.year, parseIntBase),
        siteId: requestContext.context.siteId,
        userId: requestContext.context.userID,
        //Logically consumptionDetails should be empty now we are passing dummy value as per BE requirement once it is fixed from BE we have to remove it
        consumptionDetails: [{ quantity: 23, month: 'Feb', year: 2021 }]
      };
    }
    if (modalType === 'missingData' || modalType === 'editFuelData') {
      payload = {
        ...payload,
        fuelTypeId: state?.selectedFuelMonthData?.fuleTypeId,
        emissionFactorId: state?.selectedFuelMonthData?.emissionFactorId
      };

      dispatch(FileUploadAction.hideAddFuelModal());
      result = await dataConnector.actions.create(payload);
    } else {
      payload = {
        ...payload,
        fuelTypeId: apiPayload.fuelTypeId
      };
      dispatch(FileUploadAction.hideAddFuelModal());
      result = await dataConnector.actions.create(payload);
    }
    dispatch(FileUploadActions.saveUpdatedPayload({}));
    const { notifyDescription, notifyType } = getNotifyTypeForAddFuel(result);
    notifyMessage && notifyMessage(t(notifyDescription), notifyType);
  };
  const renderFooterButtons = () => {
    return (
      <div className="upload-modal-footer">
        {isEditButtonEnabled && modalType === 'editFuelData' ? (
          <Button
            disabled={AddFuelDisabled}
            style={{ marginLeft: 'auto' }}
            type="primary"
            onClick={() => closeModal()}
          >
            {t(d.CANCEL)}
          </Button>
        ) : (
          <Button
            disabled={AddFuelDisabled || updateDisabled}
            style={{ marginLeft: 'auto' }}
            type="primary"
            onClick={() => {
              saveData();
            }}
          >
            {t(d.save)}
          </Button>
        )}
      </div>
    );
  };
  let modelCheck = ['missingData', 'editFuelData'];
  return (
    <React.Fragment>
      <Modal
        className="emaas-AddFuel-modal"
        size="large"
        closeIcon={true}
        onClose={closeModal}
        open={showAddFuelModal}
        closeOnDimmerClick={false}
      >
        <div className="AddFuel-modal-header">
          {getModalTitle(
            t,
            selectedFuelMonthData,
            modalType,
            props.activeIndexDataUpload,
            props.toggleFeatureAllUpload
          )}
          {!modelCheck.includes(modalType) && (
            <div className="AddFuel-modal-subheader-title">
              {fuelGasTypeLabelCheck(
                props.activeIndexDataUpload,
                t(d.SCOPEONESC),
                t(d.SCOEONEREF),
                props.toggleFeatureAllUpload,
                props.toggleFeatureScopeOne,
                props.toggleFeatureScopeTwo,
                t(d.SCOPETWO),
                props.toggleFeatureGAS,
                t(d.METEREDGAS)
              )}
            </div>
          )}
          <div className="AddFuel-modal-subheader">{t(d.ADDNEWFUELSUB)}</div>
        </div>

        <Modal.Content className="upload-modal-content">
          {renderModel()}
        </Modal.Content>
      </Modal>
    </React.Fragment>
  );
}

export default AddFuelModal;
